import React from "react";
import { useAppState } from "../../../Redux/ReduxHooks";

/**
 * Displays the name of the passenger of the booking.
 */
export const PassengerName: React.FC = () => {

    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    return (
        <div className="tracking-passenger-name">{bookingDetails.PassengerName}</div>
    )
}